import { render, staticRenderFns } from "./PerfilAcessoCadastro.vue?vue&type=template&id=3069d1bc&scoped=true&"
import script from "./PerfilAcessoCadastro.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3069d1bc",
  null
  
)

export default component.exports